import React from 'react';
import { Icon } from './Icon.js';
export const IconNextDouble = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M2 19L9.60526 19L15 12L9.60526 5L2 5L2 19Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M17.792 4.38965L23.1865 11.3896L23.6572 12L23.1865 12.6104L17.792 19.6104L17.4912 20H12.623L14.1641 18H16.5088L21.1328 12L16.5088 6H14.1641L12.623 4H17.4912L17.792 4.38965Z", fill: "currentColor", "data-color": "color-2", "data-stroke": "none" })));
};
//# sourceMappingURL=IconNextDouble.js.map